module.exports = __webpack_public_path__ + "static/media/commerce.94bc5cef.jpg";